var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3750B682-1EDC-4320-A228-A44F3BEA4F80") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000  1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messagingCalendarEvent",
    transform: "translate(-1310.000000, -749.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groupChatBody",
    transform: "translate(390.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message1User1",
    transform: "translate(400.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messsageControls",
    transform: "translate(460.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reply",
    transform: "translate(60.000000, 2.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.708333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.275884766,5.24064844 L6.11976758,0.194271484 C6.63129492,-0.247496094 7.4375,0.111130859 7.4375,0.797373047 L7.4375,3.45538281 C12.7708848,3.51644336 17.0000041,4.58535156 17.0000041,9.63973047 C17.0000041,11.6797637 15.6857871,13.7007715 14.233084,14.7573945 C13.7797617,15.0871348 13.1336953,14.673291 13.3008398,14.1387871 C14.8064023,9.32393555 12.5867402,8.04568164 7.4375,7.97157227 L7.4375,10.890625 C7.4375,11.5779297 6.63066406,11.9349629 6.11976758,11.4937266 L0.275884766,6.44685156 C-0.0917070312,6.12936328 -0.0922050781,5.55856836 0.275884766,5.24064844 Z",
    id: "Path",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.73ad682af18aa8a961091d180d227b8d.svg";
export { ForwardRef as ReactComponent };